import * as React from "react";
import { Pressable, StyleSheet, View } from "react-native";
import fixture from "./__test__/fixture.json";
import { Text, useTheme } from "react-native-paper";
import HeaderNav from "app/shared/components/header-nav/header-nav";
import { Block } from "@block";
import { StackActions, useNavigation } from "@react-navigation/native";
import ScreenNameType from "@navigation/nav-screens";
import { useTranslation } from "react-i18next";
import { NavTitleBar, SubtitleNavTitleBar } from "app/shared/components/nav-title-bar/nav-title-bar";
import { spacing } from "@styles/spacing";
import { useDesktopMediaQuery } from "@media-query";
import IconsYellowBanking from "app/shared/components/icons/icon-yellow-banking/IconsYellowBanking";
import { ScrollView } from "react-native-gesture-handler";
import { StackSpacing } from "@components/spacing";
import { globalShowFuture } from "app/shared/util/future";
import Animated, { useAnimatedStyle, withSpring } from "react-native-reanimated";
import { useDispatch, useSelector } from "react-redux";
import { setTransferLocalReset } from "../transfer-local/reducer/actions";
import { setTransferForeignReset } from "../transfer-foreign/reducer/actions";
import { setTransfer247Reset } from "../transfer-247/reducer/actions";
import { setTransferStockReset } from "../transfer-stock/reducer/actions";
import { setTransferCharityReset } from "../transfer-charity/reducer/actions";
import { getContactIdSelector } from "app/modules/account-management/reducer/selectors";
import GlobalModalImage, { createGlobalModalImage, globalModalImage } from "app/shared/components/modal/global-modal/global-modal-image";
import images from "app/shared/styles/images";

type PressAbleState = Readonly<{
  pressed: boolean;
  hovered?: boolean;
  focused?: boolean;
}>;

const ListTransferScreen = () => {
  const { colors, fonts } = useTheme();
  const { t, i18n } = useTranslation();
  const { dispatch } = useNavigation();
  const dispatchStore = useDispatch();

  const isDesktop = useDesktopMediaQuery();
  const contactId = useSelector(getContactIdSelector);
  const [globalModalImageRef] = React.useState<React.RefObject<any>>(createGlobalModalImage());

  const onCancel = () => {
    console.log("ListTransfer onCancel");
    dispatch(StackActions.replace(ScreenNameType.HOME));
  };

  const subtitlesArrays: Array<SubtitleNavTitleBar> = [
    {
      name: t("FUNC_TRANG_CHU"),
      onPressSubtitle: () => {
        handlerParamsCleverTap(false);
        onCancel();
      },
    },
    {
      name: t("TRANFER_CHUYEN_TIEN"),
      onPressSubtitle: () => {},
    },
  ];

  const styles = React.useMemo(
    () =>
      StyleSheet.create({
        textName: { ...fonts.medium, color: colors.text, textAlign: "center", maxWidth: 164, alignSelf: "center" },
        flatList: { flex: 1 },
      }),
    [colors.text, fonts.medium],
  );

  const handlerParamsCleverTap = (status: boolean, ct_transfer_type?: string) => {
    console.log("handlerParamsCleverTap");
    let param = {};
    param = {
      ct_channel: "ib_rb",
      ct_cccd_ID: contactId,
      ct_transfer_status: status ? "success" : "fail",
      ct_screen: "transfer",
      ct_error_message: "",
    };
    if (ct_transfer_type) {
      param = {
        ...param,
        ct_transfer_type: ct_transfer_type,
      };
    }

    return {
      eventNameCT: "ct_transfer",
      paramsCT: param,
    };
  };

  const showModalImage = (content: string) => {
    console.log('showModalImage');
    globalModalImage.show(content, globalModalImageRef);
  };

  const onPressItems = (index: number | string) => {
    // the_same_bank | the_other_bank | fastfund_napas_247 | transfer_to_psi | transfer_charity
    switch (index) {
      case 0:
        // showModalImage(images.popup_update);
        handlerParamsCleverTap(true, "the_same_bank");
        dispatchStore(setTransferLocalReset());
        dispatch(StackActions.replace(ScreenNameType.TRANS_LOCAL, { resetData: true }));
        break;
      case 1:
        // showModalImage(images.popup_update);
        handlerParamsCleverTap(true, "the_other_bank");
        dispatchStore(setTransferForeignReset());
        dispatch(StackActions.replace(ScreenNameType.TRANS_FOREIGN, { resetData: true }));
        break;
      case 2:
        // showModalImage(images.popup_update);
        handlerParamsCleverTap(true, "fastfund_napas_247");
        dispatchStore(setTransfer247Reset());
        dispatch(StackActions.replace(ScreenNameType.TRANS_247, { resetData: true }));
        break;
      case 3:
        // showModalImage(images.popup_update);
        handlerParamsCleverTap(true, "transfer_to_psi");
        dispatchStore(setTransferStockReset());
        dispatch(StackActions.replace(ScreenNameType.TRANS_STOCK, { resetData: true }));
        break;
      case 4:
        // showModalImage(images.popup_update);
        handlerParamsCleverTap(true, "transfer_charity");
        dispatchStore(setTransferCharityReset());
        dispatch(StackActions.replace(ScreenNameType.TRANS_CHARITY, { resetData: true }));
        break;
      default:
        globalShowFuture();
        break;
    }
  };

  return (
    <Block flex={1}>
      <ScrollView>
        <HeaderNav />
        <NavTitleBar title={t("TRANFER_CHUYEN_TIEN")} subtitles={subtitlesArrays} />
        <Block pv={spacing.medium} ph={isDesktop ? "5%" : 0}>
          <View style={{ flexDirection: "row", flexWrap: "wrap" }}>
            {fixture.funcitons[0].children.map((_item, _index) => (
              <View key={_index} style={[{ maxWidth: isDesktop ? "25%" : "50%", minWidth: isDesktop ? "25%" : "50%" }]}>
                <Pressable style={{ alignSelf: "center" }} onPress={() => onPressItems(_index)} key={_index}>
                  {({ hovered }: PressAbleState) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    const _buttonStyle = useAnimatedStyle(() => {
                      return {
                        justifyContent: "center",
                        alignItems: "center",
                        transform: [
                          {
                            scale: hovered ? withSpring(1.06) : withSpring(1),
                          },
                        ],
                      };
                    });
                    return (
                      <Animated.View style={_buttonStyle}>
                        <Block br={20} p={spacing.huge} bg={colors.backgroundForm} middle center>
                          <IconsYellowBanking name={_item.icon} size={64} />
                        </Block>
                        <StackSpacing size="small" />
                        <Text numberOfLines={2} style={styles.textName}>
                          {i18n.language === "vi" ? _item.name.vi : _item.name.en}
                        </Text>
                        <StackSpacing size="huge" />
                      </Animated.View>
                    );
                  }}
                </Pressable>
              </View>
            ))}
          </View>
        </Block>
        <GlobalModalImage ref={globalModalImageRef} imageRatio={1.5} buttonTitle={t("COMMON_DONG")} />
      </ScrollView>
    </Block>
  );
};

export default ListTransferScreen;
